'use strict'
const Base = require('../base.edit')
const modal = new (require('../../helpers/modal'))
const forms = new (require('../../helpers/forms'))

module.exports = class iframeWidget extends Base {

	onInit() {

		let button = document.createElement('button')
		button.className = 'formater'
		button.innerHTML = '<i class="material-icons">build</i>'
		button.onclick = this.formTags.bind(this)
		this.btnTags = button
		this._elemButtons.appendChild(button)

	}

	onDestroy() {}


	formTags() {

		let block = document.createElement('div')
		block.className = 'form-block'
		let wrapper = document.createElement('div')
		wrapper.className = 'form-wrapper'
		let div = document.createElement('div')
		div.className = 'form-group'

		let src = document.createElement('textarea')
		src.rows = 5
		src.value = this._data.src
		src.onchange = e => { this.fixPasteElem(e) }

		if ((new RegExp(/(\.|:|^)facebook\.com\//i)).test(src.value)) {
			div.appendChild(forms.input(
				'Postup:<br><ol>' +
				'<li>Navštívne stránku <a target="_blank" href="https://developers.facebook.com/docs/plugins/page-plugin/">"developers.facebook.com/docs/plugins/page-plugin/"</a></li>' +
				'<li>Do pola "Facebook Page URL" napíšte adresu Facebook stránky</li>' +
				'<li>Vygenerujte adresu tlačidlom "Get Code" o kúsok nižšie</li>' +
				'<li>Kliknite na tab "IFrame" a skopírujte parameter "src"</li>' +
				'</ol>', src))
		} else {
			div.appendChild(forms.input('Vložte embed kód alebo src', src))
		}

		wrapper.appendChild(div)
		block.appendChild(wrapper)

		let button = document.createElement('button')
		button.className = 'btn btn-primary'
		button.innerHTML = 'Odoslať'
		button.onclick = () => {
			if ((new RegExp(/(\.|:|^)youtube\.com\//i)).test(src.value) &&
				!(new RegExp(/(\.|:|^)youtube\.com\/embed\//i)).test(src.value)) {
				src.value = src.value.replace(/youtube\.com\//i, 'youtube.com/embed/')
			}
			this._data.src = src.value
			this._render()
			modal.hide()
		}
		block.appendChild(forms.actions(button))

		let title = 'Nastavenia'
		modal.show(title, block).then(() => { src.focus() })

	}

	fixPasteElem(e) {
		window.console.log(e.target.value)
		const div = document.createElement('div')
		div.innerHTML = e.target.value
		const iframe = div.querySelector('iframe')
		if (iframe && iframe.getAttribute('src')) {
			e.target.value = iframe.getAttribute('src')
		}
	}

}



//////////////////
// WEBPACK FOOTER
// ./src/widgets/iframe/iframe.edit.js
// module id = 456
// module chunks = 0